import { render, staticRenderFns } from "./AddReprints.vue?vue&type=template&id=9ffda608"
import script from "./AddReprints.vue?vue&type=script&lang=js"
export * from "./AddReprints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports